import { all } from 'redux-saga/effects';
import homeSaga from '../../pages/Home/sagas/home';
import logInSaga from '../../pages/Account/sagas/login';
import logOutSaga from '../../pages/Account/sagas/logOut';
import uploadSaga from '../../pages/Home/sagas/upload';
import paymentSaga from '../../pages/Video/saga/payment';
import albumSaga from '../../pages/Album/sagas/album';
import characterFavorite from '../../pages/Character/sagas/characterFavorite';
import giftboxSaga from '../../pages/Giftbox/sagas/giftbox';
import award from '../../pages/Award/sagas/award';
import awards from '../../pages/Award/sagas/awards';
import awardRegister from '../../pages/Award/sagas/register';
import videoSaga from '../../pages/Video/saga/video';
import characterModels from '../../pages/Character/sagas/characterModels';
import characterDetail from '../../pages/Character/sagas/characterDetail';
import logInSnsSaga from "../../pages/Account/sagas/loginSns";
import qnaSaga from '../../pages/Qna/sagas/qna';
import updateCurrentUserSaga from '../../pages/Account/sagas/updateUser';
import noticeSaga from '../../pages/Notification/sagas/notice';


export default function* RootSagas() {
  yield all([
    logInSnsSaga(),
    logInSaga(),
    homeSaga(),
    logOutSaga(),
    uploadSaga(),
    paymentSaga(),
    albumSaga(),
    characterFavorite(),
    giftboxSaga(),
    award(),
    awards(),
    awardRegister(),
    videoSaga(),
    characterModels(),
    characterDetail(),
    qnaSaga(),
    updateCurrentUserSaga(),
    noticeSaga()
  ]);
}
